import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import LinkedinLoginButton, {LinkedinSignInButton} from "./LinkedinLoginButton";
import GoogleLoginButton from "./GoogleLoginButton";
import BaseModal from "../../theme/modals/BaseModal";
import Logo from "../../theme/logo/logo";
import {openTabsOnCompletion, getAndResetLoginPath} from "../../../utils/session/authFlow";
import * as actions from '../../../store/actions'
import {addErrorAlert} from "../../../store/calls/alertLoadingDispatch";
import LoginForm from "./LoginForm";
import UserCreationForm from "./UserCreationForm";


function LoginModal({
                        prompt,
                        visible,
                        onClose = () => {},
                        onLogin = () => {},
                        onLoginFailure = () => {},
}) {
    const history = useHistory();
    const dispatch = useDispatch();
    const [error, setError]= useState(null);
    const [mode, setMode] = useState('select');

    const onLoginPath = useSelector(state => state.session.vars?.onLoginPath)
    const linkedinRedirectionURI = window.location.hostname === 'localhost' ? 'http://localhost:3000/create-account' : 'https://cleanfi.com/create-account';



    const onComplete = async (userData) => {
        await onLogin(userData);
        openTabsOnCompletion();
        if (onLoginPath) {
            history.push(getAndResetLoginPath())
        }
    }

    const onFailure = msg => {
        onLoginFailure()
        setError(msg || "There was an error on our server.")
        setTimeout(() => setError(null), 1800)
    }

    return (
        <BaseModal visible={visible} cardStyle={{border: "4px solid var(--secondary-color)"}} onClose={onClose}>
            <div className="is-flex is-flex-direction-column is-justify-content-center px-5 pb-4">
                <Logo/>
                <h5 className="is-size-5 has-text-centered has-text-weight-semibold">{prompt || "Login or join to continue"}</h5>
                {mode === 'select' &&
                    <>
                        <div className="is-flex is-justify-content-center my-1 mt-6">
                                <button
                                    className="button is-fullwidth is-primary is-medium"
                                    onClick={() => setMode("loginForm")}
                                >
                                    Login with your email address
                                </button>
                        </div>
                        <div className="is-flex is-justify-content-center my-1">
                            <LinkedinSignInButton
                                className="is-fullwidth is-medium"
                                prompt="Sign in with LinkedIn"
                                redirectionURI={linkedinRedirectionURI}
                                successCallback={onComplete}
                                failureCallback={onFailure}
                            />
                        </div>
                        <div className="is-flex is-justify-content-center my-1 mb-6">
                            <GoogleLoginButton
                                successCallback={onComplete}
                                failureCallback={onFailure}
                            />
                        </div>

                        <div className="is-flex is-justify-content-center my-1">

                                <button
                                    className="button is-fullwidth is-medium"
                                    onClick={() => setMode("createUserForm")}
                                >
                                    Create an account with your email
                                </button>
                        </div>
                    </>
                }

                {mode === "loginForm" &&
                    <LoginForm
                            onSuccess={onComplete}
                            onError={() => onFailure("Login failed")}
                        />
                }

                {mode === "createUserForm" && /// i need to log them in after creating them!!! that's the source of this error
                    <UserCreationForm
                            onCreate={onComplete}
                            // onError={() => onFailure("User Failed to Create")}
                        />

                }

                <div className="is-fullwidth is-flex is-flex-direction-column mt-5">
                    <Link to="/reset-password" className='is-flex is-justify-content-center'>
                        <button className="button is-text has-text-primary mt-4">
                            Forgot Password?
                        </button>
                    </Link>
                </div>


                {error && <div className="notification is-danger has-text-centered mt-6">
                    <i className="fas fa-warning"/> {error}
                </div>}
            </div>
        </BaseModal>
    )
}

export default LoginModal;